import queryString from 'query-string';
import type { UserPreferenceType } from '@atlassian/jira-dashboard-user-preference';
import { performGetRequest } from '@atlassian/jira-fetch';
import type { ProjectsGadgetData, ProjectsSearchParams, ProjectsGadgetEditData } from '../types';

export const validateConfigData = async ({
	projectsOrCategories,
	viewType,
	cols,
	maxResults,
	refresh,
}: ProjectsGadgetEditData) =>
	performGetRequest(
		`/rest/gadget/1.0/project/validateConfiguration?projectsOrCategories=${projectsOrCategories}&viewType=${viewType}&cols=${cols}&maxResults=${maxResults}&refresh=${refresh}`,
	);

export const getConfigData = async () =>
	performGetRequest('/rest/gadget/1.0/projectsAndProjectCategories');

export const getProjects = async (
	prefs: UserPreferenceType[],
	startAt: number,
): Promise<ProjectsGadgetData> => {
	const initialValue: ProjectsSearchParams = {
		startAt: `${startAt}`,
		maxResults: '10',
		projectsOrCategories: 'allprojects',
		showStats: 'false',
	};
	const params: ProjectsSearchParams = prefs.reduce((acc: ProjectsSearchParams, userPref) => {
		let paramName = userPref.name;
		let paramVal = userPref.value;
		if (userPref.name === 'viewType') {
			paramName = 'showStats';
			paramVal = paramVal === 'detailed' ? 'true' : 'false';
		}
		acc[paramName] = `${paramVal}`;
		return acc;
	}, initialValue);
	const urlSearchParams = queryString.stringify(params);
	return performGetRequest(`/rest/gadget/1.0/project/generate?${urlSearchParams}`);
};
